export enum EFolderActionsId {
	rename = 'rename',
	add = 'add-subfolder',
	delete = 'delete',
	move = 'move',
	download = 'download',
}

export const getFolderActions = ({
	isAddActionHidden,
	isMoveActionHidden,
	isDeleteActionHidden,
}: {
	isAddActionHidden?: boolean;
	isMoveActionHidden?: boolean;
	isDeleteActionHidden?: boolean;
}) => {
	return [
		{
			text: 'Rename',
			id: EFolderActionsId.rename,
		},
		{
			text: 'Add subfolder',
			id: EFolderActionsId.add,
			hidden: isAddActionHidden,
		},
		{
			text: 'Move',
			id: EFolderActionsId.move,
			hidden: isMoveActionHidden,
		},
		{
			text: 'Export',
			id: EFolderActionsId.download,
		},
		{
			text: 'Delete',
			id: EFolderActionsId.delete,
			hidden: isDeleteActionHidden,
		},
	];
};
